export const laughAction = (setLaughCount, fn, props, timeout = 350) => {
  setLaughCount((prev) => prev + 1);
  setTimeout(() => {
    fn(props);
  }, timeout);
};
